/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React from 'react';
import { View } from 'react-native';
import TextView from '@airasia-phoenix/react-native/components/TextView';
import Link from './Link';
import { getTextStyle } from '@airasia-phoenix/react-native/utils/utils';
import { pd } from '@airasia-phoenix/react-native/utils';
import { StyleSheet } from 'react-native-unistyles';
import IconView from '@airasia-phoenix/react-native/components/IconView';
import { FooterDownloadApp } from '../types';

interface DownloadAppProps {
  data: FooterDownloadApp;
  openUrl: (url: string) => void;
  onLinkPress?: (sectionTitle: string, linkText: string) => void;
}

export const DownloadApp: React.FC<DownloadAppProps> = ({
  data,
  onLinkPress,
}) => {
  return (
    <View>
      <TextView
        text={data.title}
        style={getTextStyle(
          pd.sys.typescale.body_text,
          pd.sys.colour.content_primary,
        )}
      />
      <View style={styles.appIconsContainer}>
        {data.apps.map((app, index) => (
          <Link
            key={index}
            url={app.url}
            onPress={() => onLinkPress?.('download_app', app.name)}
          >
            <IconView url={app.imageUrl} height={31} />
          </Link>
        ))}
      </View>
    </View>
  );
};

export default DownloadApp;

const styles = StyleSheet.create((pd) => ({
  appIconsContainer: {
    flexDirection: 'row',
    gap: pd.ref.space.spacing30.px,
  },
}));
